var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInquireIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.1,
    cx: 21.0866,
    cy: 20,
    rx: 21.0417,
    ry: 20,
    fill: "#FF4747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9181 17.7539L19.2091 18.1957L19.0763 18.7807L19.8051 18.9085C20.2813 19.0163 20.3752 19.1795 20.2716 19.6305L19.0763 24.9694C18.7621 26.3503 19.2463 27 20.385 27C21.2677 27 22.2929 26.6121 22.7578 26.0794L22.9003 25.439C22.5764 25.7099 22.1034 25.8177 21.7892 25.8177C21.3438 25.8177 21.1818 25.5206 21.2968 24.9971L22.9181 17.7539ZM23.0315 14.5395C23.0315 14.9478 22.8608 15.3393 22.5571 15.6281C22.2534 15.9168 21.8414 16.079 21.4118 16.079C20.9823 16.079 20.5703 15.9168 20.2666 15.6281C19.9628 15.3393 19.7922 14.9478 19.7922 14.5395C19.7922 14.1312 19.9628 13.7396 20.2666 13.4509C20.5703 13.1622 20.9823 13 21.4118 13C21.8414 13 22.2534 13.1622 22.5571 13.4509C22.8608 13.7396 23.0315 14.1312 23.0315 14.5395Z",
    fill: "#FF4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInquireIconRed);
export default __webpack_public_path__ + "static/media/InquireIcon_Red.0f41501126259be6a0656ce38afd7794.svg";
export { ForwardRef as ReactComponent };